// EMP (Employment) mode configuration
// When EMP mode is active, income question shows employment statuses instead of income ranges

// Income options for EMP mode (employment statuses that map to income values)
export const empIncomeOptions = [
  { text: 'Full Time', value: '5500' },
  { text: 'Part Time', value: '2500' },
  { text: 'Retired', value: '2500' },
  { text: 'Unemployed', value: '0' },
]

// Standard income options (income ranges)
export const standardIncomeOptions = [
  { text: '$5000+', value: '5500' },
  { text: '$4000 - $5000', value: '4500' },
  { text: '$3000 - $4000', value: '3500' },
  { text: '$2000 - $3000', value: '2500' },
  { text: '$1000 - $2000', value: '1500' },
  { text: "I don't have monthly income.", value: '0' },
]

// Headlines for income question
export const empIncomeHeadline = "What's Your Employment Status?"
export const standardIncomeHeadline = 'What is your approximate monthly income?'

// Chat messages for income question
export const empIncomeChat = '<p>Your employment status helps us estimate qualifying income.</p>'
export const standardIncomeChat = '<p>Calculate your available gross income including wages, retirement, investments, and rental properties.</p>'
